import TreeModel from 'tree-model'

export default class AttributeTree {
  constructor () {
    this._treeModel = new TreeModel()
    this.root = this._treeModel.parse({
      name: 'Data Sources',
      children: []
    })
  }

  addDataSource (dataSource) {
    const node = this._treeModel.parse(dataSource)
    this.root.addChild(node)
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/attributePanel/models/attributeTree.js